var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.791992L2.375 3.95866V8.70866C2.375 13.1024 5.415 17.2112 9.5 18.2087C13.585 17.2112 16.625 13.1024 16.625 8.70866V3.95866L9.5 0.791992ZM9.5 9.49241H15.0417C14.6221 12.7541 12.445 15.6595 9.5 16.5699V9.50033H3.95833V4.98783L9.5 2.52574V9.49241Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.0f8aaa0e3c9a68e3e8f8af766346e490.svg";
export { ForwardRef as ReactComponent };